(function () {
  if (!window.EgPdpFeatureCards) {
    window.EgPdpFeatureCards = {
      init(root) {
        const scopeRoot = root instanceof Element ? root : document;
        const sections = scopeRoot.querySelectorAll('[data-eg-pdp-feature-cards]:not([data-feature-cards-ready="true"])');

        sections.forEach((section) => {
          const track = section.querySelector('[data-feature-cards-track]');
          const prevButtons = Array.from(section.querySelectorAll('[data-feature-cards-prev]'));
          const nextButtons = Array.from(section.querySelectorAll('[data-feature-cards-next]'));

          if (!track) {
            section.dataset.featureCardsReady = 'true';
            return;
          }

          section.dataset.featureCardsReady = 'true';

          const controller = new AbortController();
          const signal = controller.signal;
          const originalCards = Array.from(track.querySelectorAll('.eg-pdp-feature-cards__card'));
          const infiniteEnabled = section.dataset.desktopLayout === 'slider' && originalCards.length > 1;
          const previousClones = [];
          const nextClones = [];

          function createLoopClone(card, setName) {
            const clone = card.cloneNode(true);

            clone.removeAttribute('id');
            clone.removeAttribute('data-shopify-editor-block');
            clone.removeAttribute('data-feature-card-set');
            clone.setAttribute('data-feature-card-clone', setName);
            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;

            clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
            clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
              element.setAttribute('tabindex', '-1');
            });

            return clone;
          }

          if (infiniteEnabled) {
            originalCards.forEach((card) => {
              card.setAttribute('data-feature-card-set', 'original');
              previousClones.push(createLoopClone(card, 'previous'));
              nextClones.push(createLoopClone(card, 'next'));
            });
            track.prepend(...previousClones);
            track.append(...nextClones);
          }

          const cards = Array.from(track.querySelectorAll('.eg-pdp-feature-cards__card'));
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const resizeObserver = 'ResizeObserver' in window
            ? new ResizeObserver(() => {
                updateLoopMetrics();
                scheduleLoopNormalization();
                updateControls();
              })
            : null;
          let scrollAnimationFrame = null;
          let isDragging = false;
          let dragMoved = false;
          let dragStartX = 0;
          let dragStartScroll = 0;
          let dragLastTime = 0;
          let dragVelocity = 0;
          let suppressClick = false;
          let loopStart = 0;
          let loopWidth = 0;
          let loopReady = false;
          let loopNormalizeTimer = null;

          section.dataset.featureCardsInfinite = infiniteEnabled ? 'true' : 'false';

          section.__egFeatureCardsController = controller;

          function isDesktopBento() {
            return section.dataset.desktopLayout === 'bento' && window.innerWidth >= 990;
          }

          function getScrollStep() {
            const firstCard = track.querySelector('.eg-pdp-feature-cards__card');
            if (!firstCard) {
              return track.clientWidth * 0.8;
            }

            const cardStyles = window.getComputedStyle(track);
            const gap = parseFloat(cardStyles.columnGap || cardStyles.gap || 0);
            return firstCard.getBoundingClientRect().width + gap;
          }

          function clampScroll(value) {
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
            return Math.max(0, Math.min(maxScroll, value));
          }

          function updateLoopMetrics() {
            if (!infiniteEnabled) return;

            const firstOriginal = originalCards[0];
            const firstNext = nextClones[0];
            const trackBounds = track.getBoundingClientRect();
            const originalBounds = firstOriginal.getBoundingClientRect();
            const nextBounds = firstNext.getBoundingClientRect();

            loopStart = originalBounds.left - trackBounds.left + track.scrollLeft;
            loopWidth = nextBounds.left - originalBounds.left;
            loopReady = loopWidth > 1;
          }

          function initializeLoop() {
            updateLoopMetrics();
            if (!loopReady) return;

            track.classList.add('is-loop-jumping');
            track.scrollLeft = loopStart;
            window.requestAnimationFrame(() => {
              track.classList.remove('is-loop-jumping');
            });
          }

          function normalizeLoopPosition() {
            if (!loopReady || isDragging || scrollAnimationFrame !== null) return false;

            const lowerBoundary = loopStart - loopWidth * 0.5;
            const upperBoundary = loopStart + loopWidth * 0.5;
            let adjustment = 0;

            if (track.scrollLeft < lowerBoundary) {
              adjustment = loopWidth;
            } else if (track.scrollLeft > upperBoundary) {
              adjustment = -loopWidth;
            }

            if (!adjustment) return false;

            track.classList.add('is-loop-jumping');
            track.scrollLeft += adjustment;
            window.requestAnimationFrame(() => {
              track.classList.remove('is-loop-jumping');
            });
            return true;
          }

          function scheduleLoopNormalization() {
            if (!infiniteEnabled) return;

            window.clearTimeout(loopNormalizeTimer);
            loopNormalizeTimer = window.setTimeout(() => {
              normalizeLoopPosition();
            }, 140);
          }

          function getSnapPoints() {
            const trackBounds = track.getBoundingClientRect();

            return cards.map((card) => {
              const cardBounds = card.getBoundingClientRect();
              return clampScroll(cardBounds.left - trackBounds.left + track.scrollLeft);
            });
          }

          function getNearestSnap(value) {
            const points = getSnapPoints();
            if (!points.length) return clampScroll(value);

            return points.reduce((closest, point) => (
              Math.abs(point - value) < Math.abs(closest - value) ? point : closest
            ));
          }

          function stopScrollAnimation() {
            if (scrollAnimationFrame !== null) {
              window.cancelAnimationFrame(scrollAnimationFrame);
              scrollAnimationFrame = null;
            }
            track.classList.remove('is-settling');
          }

          function animateScrollTo(value) {
            stopScrollAnimation();

            const start = track.scrollLeft;
            const target = clampScroll(value);
            const distance = target - start;

            if (reduceMotion.matches || Math.abs(distance) < 1) {
              track.scrollLeft = target;
              scheduleLoopNormalization();
              return;
            }

            const duration = Math.min(720, Math.max(480, Math.abs(distance) * 1.15));
            const startedAt = window.performance.now();

            track.classList.add('is-settling');

            const tick = (now) => {
              const progress = Math.min(1, (now - startedAt) / duration);
              const eased = 1 - Math.pow(1 - progress, 4);

              track.scrollLeft = start + distance * eased;

              if (progress < 1) {
                scrollAnimationFrame = window.requestAnimationFrame(tick);
                return;
              }

              scrollAnimationFrame = null;
              track.classList.remove('is-settling');
              normalizeLoopPosition();
              updateControls();
            };

            scrollAnimationFrame = window.requestAnimationFrame(tick);
          }

          function updateControls() {
            if (isDesktopBento()) {
              section.dataset.canScroll = 'false';
              section.dataset.scrollState = 'none';
              prevButtons.forEach((button) => {
                button.disabled = true;
              });
              nextButtons.forEach((button) => {
                button.disabled = true;
              });
              return;
            }

            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
            const currentScroll = Math.max(0, track.scrollLeft);
            const canScroll = maxScroll > 6;

            section.dataset.canScroll = canScroll ? 'true' : 'false';
            if (infiniteEnabled && canScroll) {
              section.dataset.scrollState = 'middle';
              prevButtons.forEach((button) => {
                button.disabled = false;
              });
              nextButtons.forEach((button) => {
                button.disabled = false;
              });
              return;
            }

            if (!canScroll) {
              section.dataset.scrollState = 'none';
            } else if (currentScroll <= 2) {
              section.dataset.scrollState = 'start';
            } else if (currentScroll >= maxScroll) {
              section.dataset.scrollState = 'end';
            } else {
              section.dataset.scrollState = 'middle';
            }
            prevButtons.forEach((button) => {
              button.disabled = !canScroll || currentScroll <= 2;
            });
            nextButtons.forEach((button) => {
              button.disabled = !canScroll || currentScroll >= maxScroll;
            });
          }

          function scrollByStep(direction) {
            const target = track.scrollLeft + direction * getScrollStep();
            animateScrollTo(getNearestSnap(target));
          }

          function handlePointerDown(event) {
            if (
              event.pointerType !== 'mouse'
              || event.button !== 0
              || isDesktopBento()
              || section.dataset.canScroll !== 'true'
            ) {
              return;
            }

            stopScrollAnimation();
            isDragging = true;
            dragMoved = false;
            dragStartX = event.clientX;
            dragStartScroll = track.scrollLeft;
            dragLastTime = window.performance.now();
            dragVelocity = 0;
            track.classList.add('is-dragging');
            track.setPointerCapture?.(event.pointerId);
          }

          function handlePointerMove(event) {
            if (!isDragging) return;

            const delta = event.clientX - dragStartX;
            if (!dragMoved && Math.abs(delta) > 3) {
              dragMoved = true;
            }
            if (!dragMoved) return;

            event.preventDefault();

            const now = window.performance.now();
            const nextScroll = clampScroll(dragStartScroll - delta);
            const elapsed = Math.max(1, now - dragLastTime);

            dragVelocity = (nextScroll - track.scrollLeft) / elapsed;
            dragLastTime = now;
            track.scrollLeft = nextScroll;
          }

          function finishPointerDrag(event, cancelled = false) {
            if (!isDragging) return;

            isDragging = false;
            track.classList.remove('is-dragging');

            if (track.hasPointerCapture?.(event.pointerId)) {
              track.releasePointerCapture(event.pointerId);
            }

            if (!dragMoved) return;

            suppressClick = !cancelled;
            if (suppressClick) {
              window.setTimeout(() => {
                suppressClick = false;
              }, 0);
            }
            const projected = cancelled
              ? track.scrollLeft
              : track.scrollLeft + dragVelocity * 260;

            animateScrollTo(getNearestSnap(projected));
          }

          prevButtons.forEach((button) => {
            button.addEventListener('click', () => {
              scrollByStep(-1);
            }, { signal });
          });

          nextButtons.forEach((button) => {
            button.addEventListener('click', () => {
              scrollByStep(1);
            }, { signal });
          });

          track.addEventListener('pointerdown', handlePointerDown, { signal });
          track.addEventListener('pointermove', handlePointerMove, { signal });
          track.addEventListener('pointerup', (event) => {
            finishPointerDrag(event);
          }, { signal });
          track.addEventListener('pointercancel', (event) => {
            finishPointerDrag(event, true);
          }, { signal });
          track.addEventListener('lostpointercapture', (event) => {
            finishPointerDrag(event, true);
          }, { signal });
          track.addEventListener('click', (event) => {
            if (!suppressClick) return;
            suppressClick = false;
            event.preventDefault();
            event.stopPropagation();
          }, { capture: true, signal });

          track.addEventListener('scroll', () => {
            updateControls();
            scheduleLoopNormalization();
          }, { passive: true, signal });
          window.addEventListener('resize', () => {
            updateLoopMetrics();
            scheduleLoopNormalization();
            updateControls();
          }, { signal });
          reduceMotion.addEventListener('change', () => {
            if (reduceMotion.matches) stopScrollAnimation();
          }, { signal });

          track.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', () => {
              updateControls();
            }, { signal });
          });

          resizeObserver?.observe(track);

          document.addEventListener('shopify:block:select', (event) => {
            const block = event.target.closest('.eg-pdp-feature-cards__card');

            if (!block || !section.contains(block) || isDesktopBento()) {
              return;
            }

            block.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });

            window.setTimeout(() => {
              updateControls();
            }, 220);
          }, { signal });

          signal.addEventListener('abort', () => {
            window.clearTimeout(loopNormalizeTimer);
            stopScrollAnimation();
            resizeObserver?.disconnect();
          }, { once: true });

          initializeLoop();
          updateControls();
          window.setTimeout(() => {
            updateControls();
          }, 180);
        });
      }
    };

    document.addEventListener('shopify:section:load', (event) => {
      window.EgPdpFeatureCards.init(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-eg-pdp-feature-cards]');

      if (!section || !section.__egFeatureCardsController) {
        return;
      }

      section.__egFeatureCardsController.abort();
      delete section.__egFeatureCardsController;
      delete section.dataset.featureCardsReady;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.EgPdpFeatureCards.init(document);
    }, { once: true });
  } else {
    window.EgPdpFeatureCards.init(document);
  }
})();
